const isEqualTime = (date1: Date, date2: Date) => {
  return date1.getHours() === date2.getHours() && date1.getMinutes() === date2.getMinutes();
};

export default isEqualTime;
